import joinUri from 'url-join';

export const transformImageUri = (uri: string, baseUrl: string) => {
  return /^https?:\/\//.test(uri) ? uri : joinUri(baseUrl, uri);
};
